"use client";

import { Button } from "@/components/ui/button";

interface MobileMenuButtonProps {
  onClick?: () => void;
  "aria-controls"?: string;
  "aria-expanded"?: boolean;
  className?: string;
  srLabel?: string;
  lineColorClassName?: string; // default to neutral-300 per current design
}

export function MobileMenuButton({
  onClick,
  "aria-controls": ariaControls,
  "aria-expanded": ariaExpanded,
  className,
  srLabel = "Open menu",
  lineColorClassName = "bg-white group-hover:bg-white",
}: MobileMenuButtonProps) {
  return (
    <Button
      variant="outline"
      size="icon"
      onClick={onClick}
      aria-controls={ariaControls}
      aria-expanded={ariaExpanded}
      className={`group h-11 w-11 rounded-full backdrop-blur-md bg-white/5 border border-white/20 hover:bg-white/20 hover:border-white/20 transition-all duration-200 text-neutral-300 hover:text-white ${className || ""}`}
    >
      <span className="sr-only">{srLabel}</span>
      <div className="flex flex-col items-center justify-center space-y-1.5">
        <span className={`h-0.5 w-5 ${lineColorClassName}`}></span>
        <span className={`h-0.5 w-3 ${lineColorClassName}`}></span>
      </div>
    </Button>
  );
}

export default MobileMenuButton;


